import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion"
import { useNotification } from "../../context/NotificationContext";
import { AlertTriangle,LucideCircleCheck,BellDotIcon,X,AlertCircle} from "lucide-react";
import './toast.scss'


let timeoutId: ReturnType<typeof setTimeout>

const ToastNotification = () => {

  const { notification: noti } = useNotification();
  const [newNoti, setNewNoti] = useState(false);
  const [errString, setErrString] = useState('');


  useEffect(() => {


    if (noti && noti.content !== '') {

      setErrString((noti.content).toString())

      setNewNoti(true)
    }

    timeoutId = setTimeout(() => {
      setNewNoti(false)
    }, 10000);

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [noti]);


  const closeNoti = () => {
    setNewNoti(false)
    clearTimeout(timeoutId);
  }

  const getnoticlass=()=>{
   if(noti.type){
      return noti.type
    }else{
      return 'neutral'
    }
  }


  return (<>

    <AnimatePresence>
      {newNoti === true && (
        <motion.div className="noti" key="fade"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}>

          <div className={`noti_tab ${getnoticlass()}`} >

            <div className='packOne'>

            {noti.type===null && (<BellDotIcon size={25} className="icon"></BellDotIcon>)}
            {noti.type==='success' && (<LucideCircleCheck size={25} className="icon"></LucideCircleCheck>)}
            {noti.type==='error' && (<AlertTriangle size={25} className="icon"></AlertTriangle>)}
            {noti.type==='warning' && (<AlertCircle size={25} className="icon"></AlertCircle>)}
            
              <div className='string'>{errString}</div>
            </div>

            <motion.div className='close' whileTap={{ scale: 0.7 }} onClick={closeNoti}>
              <X size={13} strokeWidth={3} className="closeIcon"></X>
            </motion.div>
          </div>

        </motion.div>)}
    </AnimatePresence>





  </>)



}

export default ToastNotification;